export default "__VITE_ASSET__w$ws3YwZ__"